<template>
  <div
    class="
      flex gap-6
      print:hidden
    "
  >
    <NuxtLink
      class="group flex items-center"
      :aria-label="$t('aria_label.mail_url')"
      :to="mailLinkUrl"
    >
      <IconMail
        class="
          stroke-gray-500/75 h-5 w-auto cursor-pointer
          group-hover-focus:stroke-red-500
        "
      />
    </NuxtLink>
    <button
      type="button"
      class="group"
      :aria-label="$t('aria_label.print')"
      @click="triggerPrintDialog()"
      @keydown.enter="triggerPrintDialog()"
    >
      <IconPrinter
        class="
          stroke-gray-500/75 h-[1.8rem] w-auto cursor-pointer
          group-hover-focus:stroke-red-500
        "
      />
    </button>
    <button
      type="button"
      class="group"
      :aria-label="$t('aria_label.network_navigation')"
      @click="navigation.getNetworkNavOpen ? navigation.setNetworkNavOpenState(false) : toggleNetworkNav()"
    >
      <IconNetwork
        class="
          stroke-gray-500/75 h-[1.8rem] w-auto cursor-pointer
          group-hover-focus:stroke-red-500
        "
      />
    </button>
    <NetworkNavigation />
  </div>
</template>

<script lang="ts" setup>
const navigation = useNavigationStore()
const entry = inject(EntryInjectionKey)

const { t } = useI18n()

const triggerPrintDialog = () => {
  navigation.setOpenState(false)
  window.print()
}

const toggleNetworkNav = () => {
  const timeout = navigation.getOpen ? 125 : 0

  navigation.setOpenState(false)
  setTimeout(() => {
    navigation.toggleNetworkNavOpen()
  }, timeout)
}

const mailLinkUrl = computed(() => {
  if (!entry?.value?.permalink) {
    return
  }

  const mailSubject = `${t('share.checkout')}: ${entry.value.title}`

  const mailBody = `${t('share.checkout')}: ${entry.value.title} -> ${encodeURIComponent(entry?.value?.permalink)}`

  return `mailto:?subject=${mailSubject}&body=${mailBody}`
})
</script>
